(function () {
  'use strict';

  window.SF = window.SF || {};
  const SF = window.SF;

  SF.WORKER = 'https://wispy-rain-c7af.chris-646.workers.dev';

  // ── Debug ──────────────────────────────────────────────────────────────────
  SF.debugSetLoaded = function () {
    const el = document.getElementById('sf-debug-js');
    if (el) el.textContent = 'YES';
  };
  SF.debugSetErr = function (err) {
    const el = document.getElementById('sf-debug-err');
    if (!el) return;
    el.textContent = String(err && err.stack ? err.stack : err);
  };
  SF.debugLog = function (line) {
    const el = document.getElementById('sf-debug-err');
    if (!el) return;
    el.textContent = (el.textContent ? el.textContent + '\n' : '') + String(line);
  };
  window.addEventListener('error', (e) => SF.debugSetErr(e.error || e.message || e));
  window.addEventListener('unhandledrejection', (e) => SF.debugSetErr(e.reason || e));
  SF.debugSetLoaded();

  // ── DOM refs ───────────────────────────────────────────────────────────────
  SF.wrapper = document.getElementById('support-flow');
  SF.main    = document.getElementById('sf-main');
  if (!SF.wrapper || !SF.main) return;

  const cfg          = document.getElementById('sf-login-config');
  const LOGIN_BASE   = cfg?.dataset?.loginBase   || '/customer_authentication/login';
  const SUPPORT_PATH = cfg?.dataset?.supportPath || '/pages/contact-support';

  SF.buildLoginUrl = function (returnHash) {
    const returnTo = SUPPORT_PATH + (returnHash ? '#' + returnHash : '');
    return LOGIN_BASE + '?return_to=' + encodeURIComponent(returnTo);
  };

  // ── Customer identity ──────────────────────────────────────────────────────
  SF.customerEmail = (SF.wrapper.dataset.customerEmail || '').trim();
  SF.customerName  = (SF.wrapper.dataset.customerName  || '').trim();
  SF.customerFirst = SF.customerName.split(' ')[0] || SF.customerName;
  SF.customerId    = (SF.wrapper.dataset.customerId    || '').trim();
  SF.customerTs    = (SF.wrapper.dataset.customerTs    || '').trim();
  SF.customerSig   = (SF.wrapper.dataset.customerSig   || '').trim();

  SF.isLoggedIn = function () {
    return (SF.wrapper.dataset.loggedIn || '').toString().toLowerCase() === 'true' ||
      SF.customerEmail.length > 0;
  };

  // ── Template helpers ───────────────────────────────────────────────────────
  SF.hasTpl = function (id) { return !!document.getElementById(id); };
  SF.tpl    = function (id) {
    const t = document.getElementById(id);
    if (!t || !t.content) throw new Error('Missing template #' + id);
    return t.content.cloneNode(true);
  };

  // ── API ────────────────────────────────────────────────────────────────────
  SF.authenticatedHeaders = function () {
    return {
      'X-Customer-Email': SF.customerEmail,
      'X-Customer-ID':    SF.customerId,
      'X-Customer-TS':    SF.customerTs,
      'X-Customer-Sig':   SF.customerSig,
    };
  };
  SF.apiPost = async function (path, body) {
    const res = await fetch(SF.WORKER + path, {
      method:  'POST',
      headers: { 'Content-Type': 'application/json', ...SF.authenticatedHeaders() },
      body:    JSON.stringify(body || {})
    });
    const d = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(d.error || 'Status ' + res.status);
    return d;
  };
  SF.apiGet = async function (path) {
    const res = await fetch(SF.WORKER + path, { headers: SF.authenticatedHeaders() });
    const d   = await res.json().catch(() => ({}));
    if (!res.ok) throw new Error(d.error || 'Status ' + res.status);
    return d;
  };

  // ── App state ──────────────────────────────────────────────────────────────
  SF.app = {
    top: '', step: '', stepStack: [],
    ordersLoaded: false, orders: [],
    issueType: null, selectedOrder: null,
    missingItems: [],
    packagingDamaged: null, parcelKeys: [],
    damagedItems: [], damagedItemDetails: {}, damagedIdx: 0,
    deliverySubType: null,
    contamItems: [], contamDetails: {}, contamIdx: 0,
    productProblemItems: [], productProblemIdx: 0, productProblemDetails: {},
    uploaders: {},
    _contactTags: [],
  };

  SF.resetFlow = function () {
    const a = SF.app;
    a.stepStack = []; a.step = 'issue';
    a.issueType = null; a.selectedOrder = null;
    a.missingItems = [];
    a.packagingDamaged = null; a.parcelKeys = [];
    a.damagedItems = []; a.damagedItemDetails = {}; a.damagedIdx = 0;
    a.deliverySubType = null;
    a.contamItems = []; a.contamDetails = {}; a.contamIdx = 0;
    a.productProblemItems = []; a.productProblemIdx = 0; a.productProblemDetails = {};
    a.uploaders = {};
    a._contactTags = [];
  };

  SF.pushStep = function (s) {
    if (SF.app.step) SF.app.stepStack.push(SF.app.step);
    SF.app.step = s;
    SF.renderStep();
  };
  SF.popStep = function () {
    SF.app.step = SF.app.stepStack.pop() || 'issue';
    SF.renderStep();
  };
  SF.loadOrders = async function () {
    if (SF.app.ordersLoaded) return;
    const d = await SF.apiGet('/orders');
    SF.app.orders = d.orders || [];
    SF.app.ordersLoaded = true;
  };

  // ── Hash routing ───────────────────────────────────────────────────────────
  const TOP_HASHES = new Set(['', 'order-problem', 'website', 'cultivation', 'other']);
  SF.getTopHash = function () {
    const h = (window.location.hash || '').replace(/^#/, '').trim().toLowerCase();
    return TOP_HASHES.has(h) ? h : '';
  };
  SF.goTop = function (hash) {
    const h = hash || '';
    if (window.location.hash === (h ? '#' + h : '')) SF.renderTop();
    else window.location.hash = h ? '#' + h : '';
  };

  // ── Utilities ──────────────────────────────────────────────────────────────
  SF.formatDate = function (iso) {
    if (!iso) return '';
    return new Date(iso).toLocaleDateString('en-GB', { day: 'numeric', month: 'long', year: 'numeric' });
  };
  SF.fulfilLabel = function (o) {
    if (!o?.dispatched_at)                    return '⏳ Being prepared';
    if (o.fulfillment_status === 'fulfilled') return '✅ Dispatched';
    return '📦 Partially dispatched';
  };
  SF.escapeHtml = function (s) {
    return (s || '').toString()
      .replaceAll('&', '&amp;').replaceAll('<', '&lt;')
      .replaceAll('>', '&gt;').replaceAll('"', '&quot;');
  };

  // ── UI helpers ─────────────────────────────────────────────────────────────
  SF.show = function (content) {
    SF.main.innerHTML = '';
    SF.main.appendChild(content);
    const heading = SF.main.querySelector('h1, h2, h3, [role="heading"]');
    if (heading) {
      if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
      heading.focus({ preventScroll: false });
    }
  };
  SF.renderFatal = function (err) {
    SF.debugSetErr(err);
    const box = document.createElement('div');
    box.className = 'sf-card';
    box.innerHTML = `<h2 class="sf-title">Error</h2>
      <pre style="white-space:pre-wrap">${SF.escapeHtml(String(err?.stack || err))}</pre>`;
    SF.main.innerHTML = '';
    SF.main.appendChild(box);
  };
  SF.setStatus = function (msg, kind) {
    const el = document.querySelector('#sf-main .sf-status-msg');
    if (!el) return;
    el.textContent = msg || '';
    el.className   = 'sf-status-msg' + (kind ? ' ' + kind : '');
    el.setAttribute('role',      kind === 'error' ? 'alert'     : 'status');
    el.setAttribute('aria-live', kind === 'error' ? 'assertive' : 'polite');
  };
  SF.makeCard = function () {
    const el = document.createElement('div');
    el.className = 'sf-card';
    return el;
  };
  SF.makeBackButton = function () {
    const btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'sf-back';
    btn.setAttribute('data-action', 'back');
    btn.textContent = '← Back';
    return btn;
  };
  SF.makeHeading = function (text) {
    const h = document.createElement('h2');
    h.className = 'sf-title'; h.textContent = text;
    return h;
  };
  SF.makeSubtitle = function (text) {
    const p = document.createElement('p');
    p.className = 'sf-subtitle'; p.textContent = text;
    return p;
  };
  SF.makeStatusEl = function () {
    const el = document.createElement('div');
    el.className = 'sf-status-msg';
    el.setAttribute('role', 'status');
    el.setAttribute('aria-live', 'polite');
    el.setAttribute('aria-atomic', 'true');
    return el;
  };
  SF.makeButton = function (text, action, className = 'sf-btn') {
    const btn = document.createElement('button');
    btn.type = 'button'; btn.className = className;
    if (action) btn.setAttribute('data-action', action);
    btn.textContent = text;
    return btn;
  };
  SF.makeOption = function (icon, text, action, dataAttr) {
    const btn = document.createElement('button');
    btn.type = 'button'; btn.className = 'sf-option';
    if (action)   btn.setAttribute('data-action', action);
    if (dataAttr) btn.setAttribute(dataAttr.name, dataAttr.value);
    const iconEl = document.createElement('span');
    iconEl.className = 'sf-option-icon'; iconEl.textContent = icon;
    iconEl.setAttribute('aria-hidden', 'true');
    const textEl = document.createElement('span');
    textEl.textContent = text;
    btn.append(iconEl, textEl);
    return btn;
  };
  SF.makeOptionsContainer = function (marginTop) {
    const el = document.createElement('div');
    el.className = 'sf-options';
    if (marginTop) el.style.marginTop = marginTop;
    return el;
  };
  SF.makeLink = function (href, text, className) {
    const a = document.createElement('a');
    a.href = href; a.textContent = text;
    if (className) a.className = className;
    return a;
  };
  SF.makeTrackingPara = function (trackingUrl, trackingNumber) {
    const p    = document.createElement('p');
    const link = SF.makeLink(trackingUrl, '📦 Track your order', 'sf-link');
    link.target = '_blank'; link.rel = 'noopener';
    p.appendChild(link);
    if (trackingNumber) p.appendChild(document.createTextNode(' (' + trackingNumber + ')'));
    return p;
  };
  SF.makeOrderNamePara = function (prefix, orderName, suffix) {
    const p = document.createElement('p');
    p.className = 'sf-subtitle';
    if (prefix) p.appendChild(document.createTextNode(prefix));
    const strong = document.createElement('strong');
    strong.textContent = orderName || '';
    p.appendChild(strong);
    if (suffix) p.appendChild(document.createTextNode(suffix));
    return p;
  };
  SF.makeField = function (labelText, inputEl, optional = false) {
    const lbl = document.createElement('label');
    lbl.className = 'sf-label';
    lbl.style.cssText = 'display:block;margin-bottom:12px;';
    const span = document.createElement('span');
    span.style.cssText = 'display:block;margin-bottom:4px;font-weight:600;';
    span.textContent   = labelText;
    if (optional) {
      const opt = document.createElement('span');
      opt.className = 'sf-label-opt'; opt.textContent = ' (optional)';
      opt.style.fontWeight = 'normal';
      span.appendChild(opt);
    }
    lbl.appendChild(span); lbl.appendChild(inputEl);
    return lbl;
  };
  SF.makeInput = function (className, type, placeholder, value = '') {
    const el = document.createElement('input');
    el.className = 'sf-input ' + className; el.type = type;
    el.placeholder = placeholder; el.value = value;
    el.style.cssText = 'width:100%;box-sizing:border-box;font-family:inherit;padding:10px 12px;border:1px solid #d1d5db;border-radius:6px;';
    return el;
  };
  SF.makeTextarea = function (className, rows, placeholder, value = '') {
    const el = document.createElement('textarea');
    el.className = 'sf-input ' + className; el.rows = rows;
    el.placeholder = placeholder; el.value = value;
    el.style.cssText = 'width:100%;box-sizing:border-box;font-family:inherit;padding:10px 12px;border:1px solid #d1d5db;border-radius:6px;min-height:120px;resize:vertical;line-height:1.5;';
    return el;
  };
  SF.makeHintBox = function (text) {
    const box = document.createElement('div');
    box.className = 'sf-hint-box';
    box.style.cssText = 'display:flex;align-items:flex-start;gap:10px;background:#fffbea;border:1px solid #f5c842;border-left:4px solid #f5c842;border-radius:6px;padding:12px 14px;margin:12px 0 16px;font-size:.92em;color:#7a5c00;line-height:1.5;';
    const icon = document.createElement('span');
    icon.textContent = '⚠️'; icon.style.cssText = 'flex-shrink:0;font-size:1.1em;margin-top:1px;';
    icon.setAttribute('aria-hidden', 'true');
    const msg = document.createElement('span');
    msg.textContent = text;
    box.append(icon, msg);
    return box;
  };
  SF.makeInfoBox = function (htmlOrText, isHtml = false) {
    const box = document.createElement('div');
    box.className = 'sf-info-box';
    box.style.cssText = 'display:flex;align-items:flex-start;gap:10px;background:#eef6ff;border:1px solid #90c8f8;border-left:4px solid #2196f3;border-radius:6px;padding:12px 14px;margin:16px 0;font-size:.92em;color:#0d3c61;line-height:1.5;';
    const icon = document.createElement('span');
    icon.textContent = 'ℹ️'; icon.style.cssText = 'flex-shrink:0;font-size:1.1em;margin-top:1px;';
    icon.setAttribute('aria-hidden', 'true');
    const msg = document.createElement('span');
    if (isHtml) msg.innerHTML = htmlOrText;
    else        msg.textContent = htmlOrText;
    box.append(icon, msg);
    return box;
  };
  SF.makeProductIdentity = function (item) {
    const wrap = document.createElement('div');
    wrap.style.cssText = 'display:flex;align-items:center;gap:14px;margin:4px 0 16px;';
    if (item.image) {
      const img = document.createElement('img');
      img.src = item.image; img.alt = '';
      img.style.cssText = 'width:64px;height:64px;object-fit:cover;border-radius:8px;flex-shrink:0;background:#f0f0f0;border:1px solid #e5e7eb;';
      img.setAttribute('aria-hidden', 'true');
      wrap.appendChild(img);
    }
    const text  = document.createElement('div');
    const title = document.createElement('p');
    title.style.cssText = 'margin:0;font-weight:600;font-size:.92em;line-height:1.3;color:#111;';
    title.textContent   = item.title;
    text.appendChild(title);
    if (item.variant_title) {
      const variant = document.createElement('p');
      variant.style.cssText = 'margin:2px 0 0;font-size:.85em;color:#6b7280;';
      variant.textContent   = item.variant_title;
      text.appendChild(variant);
    }
    wrap.appendChild(text);
    return wrap;
  };

  // ── Uploader ───────────────────────────────────────────────────────────────
  SF.mountUploader = function (container, { label = 'Attach files', multiple = true } = {}) {
    if (!container) return { getKeys: () => [], isUploading: () => false };
    const frag  = SF.tpl('tpl-dropzone');
    const dz    = frag.querySelector('.sf-dropzone');
    const input = frag.querySelector('input[type="file"]');
    const btn   = frag.querySelector('.sf-attach-btn');
    const list  = frag.querySelector('.sf-file-list');
    if (btn) btn.textContent = '📎 ' + label;
    if (multiple && input) input.setAttribute('multiple', '');
    container.innerHTML = '';
    container.appendChild(frag);
    let staged = [];
    function isUploading() { return staged.some(s => s.status === 'uploading'); }
    function render() {
      if (!list) return;
      list.innerHTML = '';
      staged.forEach((e, idx) => {
        const row   = document.createElement('div');
        row.className = 'sf-file-item';
        const name  = document.createElement('span');
        name.textContent = e.file.name;
        const badge = document.createElement('span');
        badge.className   = 'sf-file-badge ' + (e.status || '');
        badge.textContent = e.status === 'uploading' ? '⏳' : e.status === 'done' ? '✓' : '✗';
        badge.setAttribute('aria-hidden', 'true');
        const del = document.createElement('button');
        del.type = 'button'; del.className = 'sf-file-del'; del.textContent = '✕';
        del.setAttribute('aria-label', 'Remove ' + e.file.name);
        del.addEventListener('click', () => { staged.splice(idx, 1); render(); });
        row.append(name, badge, del);
        list.appendChild(row);
      });
    }
    async function uploadOne(entry) {
      const fd = new FormData();
      fd.append('file', entry.file);
      try {
        const res  = await fetch(SF.WORKER + '/upload', { method: 'POST', body: fd });
        const data = await res.json().catch(() => ({}));
        if (!res.ok || !data.success) throw new Error(data.error || 'Upload failed');
        entry.key = data.key; entry.status = 'done';
      } catch { entry.status = 'error'; }
      render();
    }
    function handleFiles(files) {
      for (const f of files) {
        if (staged.length >= 10) break;
        staged.push({ file: f, key: null, status: 'uploading' });
        render();
        uploadOne(staged[staged.length - 1]);
      }
    }
    btn?.addEventListener('click', () => input?.click());
    input?.addEventListener('change', () => { handleFiles([...(input.files || [])]); input.value = ''; });
    dz?.addEventListener('dragover',  e => { e.preventDefault(); dz.classList.add('dragover'); });
    dz?.addEventListener('dragleave', () => dz.classList.remove('dragover'));
    dz?.addEventListener('drop', e => {
      e.preventDefault(); dz.classList.remove('dragover');
      handleFiles([...(e.dataTransfer?.files || [])]);
    });
    return { getKeys: () => staged.filter(s => s.key).map(s => s.key), isUploading };
  };

  // ── Item / order list builders ─────────────────────────────────────────────
  SF.buildItemList = function (lineItems, selectedIds, onToggle) {
    const wrap = document.createElement('div');
    wrap.className = 'sf-item-list';
    lineItems.forEach(li => {
      const row = document.createElement('label');
      row.className = 'sf-item-check-row';
      row.style.cssText = 'display:flex;align-items:center;gap:12px;cursor:pointer;padding:10px 0;border-bottom:1px solid #f0f0f0;';
      const input = document.createElement('input');
      input.type = 'checkbox'; input.checked = selectedIds.has(String(li.id));
      input.addEventListener('change', () => onToggle(li, input.checked));
      const img = document.createElement('img');
      img.className = 'sf-item-thumb'; img.alt = '';
      img.style.cssText = 'width:48px;height:48px;object-fit:cover;border-radius:6px;flex-shrink:0;background:#f0f0f0;';
      img.setAttribute('aria-hidden', 'true');
      if (li.image) { img.src = li.image; } else { img.style.display = 'none'; }
      const text = document.createElement('span');
      text.className   = 'sf-item-label';
      text.textContent = li.title + (li.variant_title ? ' — ' + li.variant_title : '');
      row.append(input, img, text);
      wrap.appendChild(row);
    });
    return wrap;
  };
  SF.buildOrderList = function (orders, selectedId, onSelect) {
    const group = document.createElement('div');
    group.setAttribute('role', 'radiogroup');
    group.setAttribute('aria-label', 'Select an order');
    orders.forEach(o => {
      const clone = SF.tpl('tpl-order-card');
      const card  = clone.querySelector('.sf-order-card') || clone.firstElementChild;
      if (!card) return;
      const isSelected = String(o.id) === String(selectedId);
      card.setAttribute('data-order-id', String(o.id));
      card.setAttribute('role', 'radio');
      card.setAttribute('aria-checked', String(isSelected));
      card.setAttribute('tabindex', isSelected ? '0' : '-1');
      card.querySelectorAll('*').forEach(el => {
        el.setAttribute('data-order-id', String(o.id));
        el.style.pointerEvents = 'none';
      });
      const nameEl  = card.querySelector('.sf-order-name');
      const metaEl  = card.querySelector('.sf-order-meta');
      const itemsEl = card.querySelector('.sf-order-items');
      if (nameEl)  nameEl.textContent  = o.name || '';
      if (metaEl)  metaEl.textContent  = SF.formatDate(o.created_at) + ' · ' + SF.fulfilLabel(o);
      if (itemsEl) itemsEl.textContent = (o.line_items?.length || 0) + ' item(s)';
      if (isSelected) card.classList.add('selected');
      card.addEventListener('click', () => onSelect(isSelected ? null : o));
      card.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); onSelect(isSelected ? null : o); }
        if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
          e.preventDefault();
          const next = card.nextElementSibling;
          if (next) { next.setAttribute('tabindex', '0'); next.focus(); card.setAttribute('tabindex', '-1'); }
        }
        if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
          e.preventDefault();
          const prev = card.previousElementSibling;
          if (prev) { prev.setAttribute('tabindex', '0'); prev.focus(); card.setAttribute('tabindex', '-1'); }
        }
      });
      group.appendChild(card);
    });
    return group;
  };
  SF.getContinueBtn = function (root) {
    return (
      root.querySelector('[data-action="confirm-orders"]') ||
      root.querySelector('.sf-continue-btn') ||
      [...root.querySelectorAll('button,a,[role="button"]')]
        .find(b => (b.textContent || '').trim().toLowerCase() === 'continue')
    );
  };

  // ── Ticket context / subjects / prefill ────────────────────────────────────
  SF.buildTicketContext = function (extraLines = []) {
    const a = SF.app;
    const lines = ['--- Support Context ---'];
    lines.push('Customer: ' + (SF.customerName  || '(unknown)'));
    lines.push('Email:    ' + (SF.customerEmail || '(unknown)'));
    if (a.selectedOrder) {
      const o = a.selectedOrder;
      lines.push('Order:    ' + o.name + ' (' + o.id + ')');
      lines.push('Placed:   ' + SF.formatDate(o.created_at));
      lines.push('Status:   ' + (o.fulfillment_status || 'unknown'));
      if (o.dispatched_at)   lines.push('Dispatched:   ' + SF.formatDate(o.dispatched_at));
      if (o.tracking_number) lines.push('Tracking #:   ' + o.tracking_number);
      if (o.tracking_url)    lines.push('Tracking URL: ' + o.tracking_url);
    }
    if (a.issueType)       lines.push('Issue type:        ' + a.issueType);
    if (a.deliverySubType) lines.push('Delivery sub-type: ' + a.deliverySubType);
    if (a.missingItems?.length)
      lines.push('Missing items: ' + a.missingItems.map(x => x.title).join(', '));
    if (a.damagedItems?.length)
      lines.push('Damaged items: ' + a.damagedItems.map(x => x.title).join(', '));
    if (a.contamItems?.length)
      lines.push('Contaminated items: ' + a.contamItems.map(x => x.title).join(', '));
    if (a.productProblemItems?.length)
      lines.push('Product problem items: ' + a.productProblemItems.map(x => x.title).join(', '));
    for (const l of extraLines) if (l) lines.push(l);
    lines.push('--- End Context ---');
    return lines.join('\n');
  };
  SF.withContext = function (userMessage, extraLines = []) {
    return SF.buildTicketContext(extraLines) + '\n\n' + (userMessage || '(no message provided)');
  };
  SF.buildSubject = function () {
    const ord  = SF.app.selectedOrder;
    const name = ord?.name || '';
    const map  = {
      'missing-item':    `${name} had missing items`,
      'damaged':         `${name} had damaged items`,
      'not-arrived':     `${name} — delivery problem`,
      'contaminated':    `${name} — contamination report`,
      'product-problem': `${name} — product problem`,
    };
    return 'Order ' + (map[SF.app.issueType] || (name ? name + ' — support request' : 'Support request'));
  };
  SF.buildMissingItemMessage = function () {
    const orderName = SF.app.selectedOrder?.name || '';
    const itemLines = SF.app.missingItems.map((item, i) => `${i + 1}. ${item.title}`).join('\n');
    return [
      'Hi MycoPunks team,', '',
      `Some items were missing from my order (${orderName})`, '',
      itemLines, '',
      'Can you let me know next steps?', '',
      'Thanks,', SF.customerFirst,
    ].join('\n');
  };
  SF.buildDeliveryNotReceivedMessage = function () {
    const orderName = SF.app.selectedOrder?.name || '';
    return [
      'Hi MycoPunks team,', '',
      `Order ${orderName} says it was delivered, I've checked with neighbours and around my property and I can't find it.`, '',
      'Please can you let me know next steps?', '',
      'Thanks,', SF.customerFirst,
    ].join('\n');
  };

  // ── Submit functions ───────────────────────────────────────────────────────
  SF.submitContactForm = async function () {
    const submitBtn = SF.main.querySelector('[data-action="submit-contact"]');
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Sending…'; }
    const resolvedName  = SF.isLoggedIn() ? (SF.customerName  || 'Customer') : (SF.main.querySelector('.sf-cf-name')?.value?.trim()  || '');
    const resolvedEmail = SF.isLoggedIn() ? (SF.customerEmail || '')         : (SF.main.querySelector('.sf-cf-email')?.value?.trim() || '');
    const subject = SF.main.querySelector('.sf-cf-subject')?.value?.trim() || '';
    const message = SF.main.querySelector('.sf-cf-message')?.value?.trim() || '';
    const keys    = SF.app.uploaders.contact?.getKeys?.() || [];
    const tags    = SF.app._contactTags || [];
    const fail = (msg) => {
      SF.setStatus(msg, 'error');
      if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = 'Create support ticket'; }
    };
    if (!resolvedName)  { fail('Please enter your name.');  return; }
    if (!resolvedEmail) { fail('Please enter your email.'); return; }
    if (!subject)       { fail('Please enter a subject.');  return; }
    if (!message)       { fail('Please enter a message.');  return; }
    SF.setStatus('Sending…');
    try {
      await SF.apiPost('/tickets', {
        name: resolvedName, email: resolvedEmail, subject,
        message: SF.withContext(message), attachmentKeys: keys, tags,
      });
      SF.pushStep('success');
    } catch (e) { fail(e.message); }
  };
  SF.submitOther = async function () {
    const resolvedName  = SF.isLoggedIn() ? (SF.customerName  || 'Customer') : (SF.main.querySelector('.sf-cf-name')?.value?.trim()  || '');
    const resolvedEmail = SF.isLoggedIn() ? (SF.customerEmail || '')         : (SF.main.querySelector('.sf-cf-email')?.value?.trim() || '');
    const subject = SF.main.querySelector('.sf-cf-subject')?.value?.trim() || '';
    const message = SF.main.querySelector('.sf-cf-message')?.value?.trim() || '';
    const keys    = SF.app.uploaders.other?.getKeys?.() || [];
    if (!resolvedName)  { SF.setStatus('Please enter your name.',  'error'); return; }
    if (!resolvedEmail) { SF.setStatus('Please enter your email.', 'error'); return; }
    if (!subject)       { SF.setStatus('Please enter a subject.',  'error'); return; }
    if (!message)       { SF.setStatus('Please enter a message.',  'error'); return; }
    SF.setStatus('Sending…');
    try {
      await SF.apiPost('/tickets', {
        name: resolvedName, email: resolvedEmail, subject,
        message: [
          '--- Support Context ---',
          'Customer: ' + (SF.customerName  || '(unknown)'),
          'Email:    ' + (SF.customerEmail || '(unknown)'),
          'Category: Other / general enquiry',
          '--- End Context ---', '', message,
        ].join('\n'),
        attachmentKeys: keys, tags: ['other'],
      });
      SF.renderSuccess();
    } catch (e) { SF.setStatus(e.message, 'error'); }
  };
  SF.submitDamaged = async function () {
    SF.setStatus('Submitting…');
    try {
      const userMsg    = SF.main.querySelector('.sf-extra-message')?.value?.trim() || '';
      const extraLines = ['Packaging damaged: ' + (SF.app.packagingDamaged ? 'Yes' : 'No')];
      for (const li of SF.app.damagedItems) {
        const det = SF.app.damagedItemDetails[li.id] || {};
        extraLines.push('Damaged item: ' + li.title);
        if (det.description) extraLines.push('  Damage description: ' + det.description);
      }
      const keys = [
        ...(SF.app.parcelKeys || []),
        ...Object.values(SF.app.damagedItemDetails).flatMap(d => d.attachmentKeys || []),
      ];
      await SF.apiPost('/tickets', {
        name: SF.customerName || 'Customer', email: SF.customerEmail || '',
        subject: 'Order ' + (SF.app.selectedOrder?.name || '') + ' had damaged items',
        message: SF.withContext(userMsg, extraLines), attachmentKeys: keys,
        tags: ['order', 'issue:damaged'],
      });
      SF.pushStep('success');
    } catch (e) { SF.setStatus(e.message, 'error'); }
  };
  SF.submitContam = async function () {
    SF.setStatus('Submitting…');
    try {
      const notes      = SF.main.querySelector('.sf-contam-notes')?.value?.trim() || '';
      const extraLines = [];
      const allKeys    = [];
      for (const item of SF.app.contamItems) {
        const det  = SF.app.contamDetails[item.id] || {};
        const keys = SF.app.uploaders['contam_' + item.id]?.getKeys?.() || [];
        extraLines.push('Contaminated item: ' + item.title);
        if (det.lot)        extraLines.push('  Lot/date label: ' + det.lot);
        if (det.inoculated) extraLines.push('  Inoculated: '     + det.inoculated);
        allKeys.push(...keys);
      }
      if (notes) extraLines.push('Additional notes: ' + notes);
      await SF.apiPost('/tickets', {
        name: SF.customerName || 'Customer', email: SF.customerEmail || '',
        subject: 'Order ' + (SF.app.selectedOrder?.name || '') + ' — contamination report',
        message: SF.withContext('', extraLines), attachmentKeys: allKeys,
        tags: ['order', 'issue:contamination'],
      });
      SF.pushStep('success');
    } catch (e) { SF.setStatus(e.message, 'error'); }
  };
  SF.submitProductProblem = async function () {
    SF.setStatus('Submitting…');
    try {
      const extraLines = [];
      const allKeys    = [];
      for (const item of SF.app.productProblemItems) {
        const det  = SF.app.productProblemDetails[item.id] || {};
        const keys = SF.app.uploaders['product_' + item.id]?.getKeys?.() || [];
        extraLines.push('Product: ' + item.title);
        if (det.description) extraLines.push('  Issue: ' + det.description);
        allKeys.push(...keys);
      }
      await SF.apiPost('/tickets', {
        name: SF.customerName || 'Customer', email: SF.customerEmail || '',
        subject: 'Order ' + (SF.app.selectedOrder?.name || '') + ' — product problem',
        message: SF.withContext('', extraLines), attachmentKeys: allKeys,
        tags: ['order', 'issue:product-problem'],
      });
      SF.pushStep('success');
    } catch (e) { SF.setStatus(e.message, 'error'); }
  };

  // ── Shared screens ─────────────────────────────────────────────────────────
  SF.renderSuccess = function () {
    const card = SF.makeCard();
    card.appendChild(SF.makeHeading('Request received ✓'));
    card.appendChild(SF.makeSubtitle("We'll be in touch shortly via email."));
    card.appendChild(SF.makeInfoBox('Support is managed entirely via email. No need to create additional requests — simply reply to our email when you receive it.'));
    card.appendChild(SF.makeButton('← Back to support', 'back', 'sf-btn sf-btn--ghost'));
    SF.show(card);
  };
  SF.renderNotLoggedIn = function () {
    const frag = SF.tpl('tpl-not-logged-in');
    const card = frag.querySelector('.sf-card') || frag.firstElementChild;
    if (!card) { SF.show(frag); return; }
    const returnHash   = SF.getTopHash() || 'order-problem';
    const loginUrl     = SF.buildLoginUrl(returnHash);
    const registerBase = card.querySelector('a[href*="register"]')?.getAttribute('href')?.split('?')[0] || '/account/register';
    const signupUrl    = registerBase + '?return_to=' + encodeURIComponent('/pages/contact-support#' + returnHash);
    card.innerHTML = '';
    card.appendChild(SF.makeBackButton());
    card.appendChild(SF.makeHeading('Contact Support'));
    card.appendChild(SF.makeSubtitle('Please log in so we can pull up your orders.'));
    const info = document.createElement('div');
    info.className = 'sf-info-box';
    info.textContent = 'Log in using the email address associated with your order.';
    card.appendChild(info);
    card.appendChild(SF.makeLink(loginUrl, 'Log in to continue', 'sf-btn'));
    const guestNote = document.createElement('p');
    guestNote.style.cssText = 'margin-top:16px;font-size:.9em;color:#666;';
    guestNote.appendChild(document.createTextNode('Checked out as a guest? '));
    guestNote.appendChild(SF.makeLink(signupUrl, 'Create an account', 'sf-link'));
    guestNote.appendChild(document.createTextNode(' using the email used for your order.'));
    card.appendChild(guestNote);
    SF.show(frag);
  };
  SF.renderContactForm = function ({ subject = '', message = '', tags = [] } = {}) {
    const card         = SF.makeCard();
    const uploaderWrap = document.createElement('div');
    uploaderWrap.className = 'sf-cf-uploader-wrap';
    card.appendChild(SF.makeBackButton());
    card.appendChild(SF.makeHeading('Contact Support'));
    card.appendChild(SF.makeSubtitle("Fill in the details below and we'll get back to you via email."));
    card.appendChild(SF.makeStatusEl());
    if (!SF.isLoggedIn()) {
      card.appendChild(SF.makeField('Name',  SF.makeInput('sf-cf-name',  'text',  'Your name',  SF.customerName)));
      card.appendChild(SF.makeField('Email', SF.makeInput('sf-cf-email', 'email', 'Your email', SF.customerEmail)));
    }
    card.appendChild(SF.makeField('Subject', SF.makeInput('sf-cf-subject', 'text', "What's it about?", subject)));
    card.appendChild(SF.makeField('Message', SF.makeTextarea('sf-cf-message', 10, 'Tell us more…', message)));
    card.appendChild(uploaderWrap);
    card.appendChild(SF.makeButton('Create support ticket', 'submit-contact'));
    SF.app.uploaders.contact = SF.mountUploader(uploaderWrap, { label: 'Attach files' });
    SF.app._contactTags      = tags;
    SF.show(card);
  };
  SF.renderOtherForm = function () {
    const card         = SF.makeCard();
    const uploaderWrap = document.createElement('div');
    uploaderWrap.className = 'sf-cf-uploader-wrap';
    card.appendChild(SF.makeBackButton());
    card.appendChild(SF.makeHeading('Get in touch'));
    card.appendChild(SF.makeSubtitle("Fill in the form below and we'll get back to you via email."));
    card.appendChild(SF.makeStatusEl());
    if (!SF.isLoggedIn()) {
      card.appendChild(SF.makeField('Name',  SF.makeInput('sf-cf-name',  'text',  'Your name',  SF.customerName)));
      card.appendChild(SF.makeField('Email', SF.makeInput('sf-cf-email', 'email', 'Your email', SF.customerEmail)));
    }
    card.appendChild(SF.makeField('Subject', SF.makeInput('sf-cf-subject', 'text', "What's it about?")));
    card.appendChild(SF.makeField('Message', SF.makeTextarea('sf-cf-message', 10, 'Tell us more…')));
    card.appendChild(uploaderWrap);
    card.appendChild(SF.makeButton('Create support ticket', 'submit-other'));
    SF.app.uploaders.other = SF.mountUploader(uploaderWrap, { label: 'Attach files' });
    SF.show(card);
  };

  // ── Step renderer ──────────────────────────────────────────────────────────
  SF.renderStep = function () {
    SF.debugLog('step=' + SF.app.step);
    const app = SF.app;
    try {
      switch (app.step) {

        case 'issue': {
          const frag    = SF.tpl('tpl-choose-issue');
          const heading = frag.querySelector('.sf-title, h2, h1');
          if (heading) heading.textContent = 'How can we help?';
          SF.show(frag);
          break;
        }

        case 'select-order': {
          const frag    = SF.tpl('tpl-select-orders');
          const heading = frag.querySelector('.sf-title, h2, h1');
          const headingMap = {
            'missing-item':    'Which order had missing items?',
            'damaged':         'Which order had damaged items?',
            'not-arrived':     'Which order had a delivery problem?',
            'contaminated':    'Which order had contaminated products?',
            'product-problem': 'Which order has the product problem?',
          };
          if (heading) heading.textContent = headingMap[app.issueType] || 'Which order number was affected?';
          const list = frag.querySelector('#sf-order-list');
          if (!list) throw new Error('tpl-select-orders missing #sf-order-list');
          list.innerHTML = '';
          list.appendChild(SF.buildOrderList(
            app.orders,
            app.selectedOrder ? String(app.selectedOrder.id) : null,
            (o) => { app.selectedOrder = o; SF.renderStep(); }
          ));
          const cont = SF.getContinueBtn(frag);
          if (cont) cont.disabled = !app.selectedOrder;
          SF.show(frag);
          break;
        }

        case 'delivery-type': {
          const card = SF.makeCard();
          const opts = SF.makeOptionsContainer();
          opts.appendChild(SF.makeOption('📭', "My order still hasn't arrived",                null, { name: 'data-delivery', value: 'not-received' }));
          opts.appendChild(SF.makeOption('📍', "Tracking says delivered, but I don't have it", null, { name: 'data-delivery', value: 'wrong-address' }));
          opts.appendChild(SF.makeOption('✉️', 'Other delivery problem',                        null, { name: 'data-delivery', value: 'other' }));
          card.appendChild(SF.makeBackButton());
          card.appendChild(SF.makeHeading('What happened with your delivery?'));
          card.appendChild(SF.makeSubtitle('Select the option that best describes your issue.'));
          card.appendChild(opts);
          SF.show(card);
          break;
        }

        case 'delivery-info': {
          const o    = app.selectedOrder;
          const card = SF.makeCard();
          card.appendChild(SF.makeBackButton());
          card.appendChild(SF.makeHeading('Order status'));
          if (!o.dispatched_at) {
            const p = document.createElement('p');
            p.className = 'sf-subtitle';
            p.innerHTML = 'Your order is still being prepared by our team. To get an idea of how long things might be, you can check our <a href="/pages/service-lead-times" class="sf-link">lead times page</a>.';
            card.appendChild(p);
            SF.show(card);
            break;
          }
          const days = o.working_days_since_dispatch || 0;
          card.appendChild(SF.makeOrderNamePara('Order ', o.name, ' was dispatched on ' + SF.formatDate(o.dispatched_at) + '.'));
          if (o.tracking_url) card.appendChild(SF.makeTrackingPara(o.tracking_url, o.tracking_number));
          card.appendChild(SF.makeStatusEl());
          if (days < 4) {
            card.appendChild(SF.makeHintBox('It\'s only been ' + days + ' working day' + (days !== 1 ? 's' : '') + ' since we shipped your order. Please allow a little more time for it to arrive before raising a case.'));
            card.appendChild(SF.makeButton('I think there is a problem with the delivery', 'delivery-force-contact', 'sf-btn sf-btn--ghost'));
          } else {
            const opts = SF.makeOptionsContainer('16px');
            opts.appendChild(SF.makeOption('🤷‍♂️', "I still haven't received it", 'delivery-still-missing'));
            card.appendChild(opts);
          }
          SF.show(card);
          break;
        }

        case 'delivery-roadblock': {
          const card = SF.makeCard();
          card.appendChild(SF.makeBackButton());
          card.appendChild(SF.makeHeading('Before we raise a case…'));
          card.appendChild(SF.makeHintBox('Sometimes couriers will leave items with neighbours or in a "safe place" — please check around your property and with nearby neighbours before continuing.'));
          card.appendChild(SF.makeStatusEl());
          const opts = SF.makeOptionsContainer('16px');
          opts.appendChild(SF.makeOption('🤷‍♂️', "I've checked and still can't find it", 'delivery-still-missing'));
          card.appendChild(opts);
          SF.show(card);
          break;
        }

        case 'delivery-message':
          SF.renderContactForm({
            subject: SF.buildSubject(),
            message: SF.buildDeliveryNotReceivedMessage(),
            tags:    ['order', 'issue:delivery', 'subtype:not-received'],
          });
          break;

        case 'missing-item': {
          const frag    = SF.tpl('tpl-missing-item-new');
          const heading = frag.querySelector('.sf-title, h2, h1');
          if (heading) heading.textContent = 'Which items were missing in the order?';
          const list = frag.querySelector('.sf-item-list');
          if (!list) throw new Error('tpl-missing-item-new missing .sf-item-list');
          list.parentNode.insertBefore(SF.makeHintBox('Sometimes smaller items can get lost in amongst the packaging — make sure to check in the void fill paper.'), list);
          const selectedIds = new Set(app.missingItems.map(x => String(x.id)));
          list.replaceWith(SF.buildItemList(app.selectedOrder?.line_items || [], selectedIds, (li, checked) => {
            if (checked) { if (!app.missingItems.some(x => String(x.id) === String(li.id))) app.missingItems.push(li); }
            else { app.missingItems = app.missingItems.filter(x => String(x.id) !== String(li.id)); }
          }));
          SF.show(frag);
          break;
        }

        case 'damaged-packaging':
          SF.show(SF.tpl('tpl-damaged-packaging'));
          break;

        case 'damaged-items': {
          const frag = SF.tpl('tpl-damaged-items');
          if (app.packagingDamaged) {
            app.uploaders.parcel = SF.mountUploader(frag.querySelector('.sf-parcel-uploader'), { label: 'Upload parcel photo' });
          } else {
            const uploadBlock = frag.querySelector('.sf-parcel-uploader')?.closest('.sf-upload-block');
            if (uploadBlock) uploadBlock.remove();
          }
          const list = frag.querySelector('.sf-item-list');
          if (!list) throw new Error('tpl-damaged-items missing .sf-item-list');
          const selectedIds = new Set(app.damagedItems.map(x => String(x.id)));
          list.replaceWith(SF.buildItemList(app.selectedOrder?.line_items || [], selectedIds, (li, checked) => {
            if (checked) { if (!app.damagedItems.some(x => String(x.id) === String(li.id))) app.damagedItems.push(li); }
            else { app.damagedItems = app.damagedItems.filter(x => String(x.id) !== String(li.id)); }
          }));
          SF.show(frag);
          break;
        }

        case 'damaged-item-detail': {
          const item = app.damagedItems[app.damagedIdx];
          if (!item) { SF.pushStep('damaged-extra'); return; }
          const frag    = SF.tpl('tpl-damaged-item-detail');
          const stepEl  = frag.querySelector('.sf-damaged-step');
          if (stepEl) stepEl.textContent = 'Item ' + (app.damagedIdx + 1) + ' of ' + app.damagedItems.length;
          const titleEl    = frag.querySelector('.sf-damaged-item-title');
          const identityEl = SF.makeProductIdentity(item);
          if (titleEl) titleEl.replaceWith(identityEl);
          else frag.querySelector('.sf-card')?.prepend(identityEl);
          app.uploaders.item = SF.mountUploader(frag.querySelector('.sf-damaged-item-uploader'), { label: 'Upload item photo(s)' });
          const existing = app.damagedItemDetails[item.id];
          const desc     = frag.querySelector('.sf-damaged-item-desc');
          if (desc && existing?.description) desc.value = existing.description;
          SF.show(frag);
          break;
        }

        case 'damaged-extra':
          SF.show(SF.tpl('tpl-damaged-extra'));
          break;

        case 'contam-select': {
          const card = SF.makeCard();
          card.appendChild(SF.makeBackButton());
          card.appendChild(SF.makeHeading('Which products contaminated?'));
          card.appendChild(SF.makeSubtitle('Select all affected items from your order.'));
          card.appendChild(SF.makeStatusEl());
          const selectedIds = new Set(app.contamItems.map(x => String(x.id)));
          card.appendChild(SF.buildItemList(app.selectedOrder?.line_items || [], selectedIds, (li, checked) => {
            if (checked) { if (!app.contamItems.some(x => String(x.id) === String(li.id))) app.contamItems.push(li); }
            else { app.contamItems = app.contamItems.filter(x => String(x.id) !== String(li.id)); }
          }));
          card.appendChild(SF.makeButton('Continue', 'contam-items-next'));
          SF.show(card);
          break;
        }

        case 'contam-detail': {
          const item = app.contamItems[app.contamIdx];
          if (!item) { SF.pushStep('contam-submit'); return; }
          const existing = app.contamDetails[item.id] || {};
          const card     = SF.makeCard();
          const stepEl   = document.createElement('p');
          stepEl.className   = 'sf-subtitle';
          stepEl.textContent = 'Item ' + (app.contamIdx + 1) + ' of ' + app.contamItems.length;
          card.appendChild(SF.makeBackButton());
          card.appendChild(stepEl);
          card.appendChild(SF.makeProductIdentity(item));
          card.appendChild(SF.makeStatusEl());
          const lotInput = SF.makeInput('sf-contam-lot', 'text', 'e.g. LOT-1234 or 2024-03-15', existing.lot || '');
          card.appendChild(SF.makeField('Lot number or date label', lotInput));
          card.appendChild(SF.makeHintBox('The lot number or date label can be found printed on the bag label.'));
          const ynWrap = document.createElement('div');
          ynWrap.style.cssText = 'margin-bottom:14px;';
          const ynLabel = document.createElement('p');
          ynLabel.style.cssText = 'font-weight:600;margin:0 0 8px;';
          ynLabel.textContent   = 'Did you inoculate this product?';
          ynWrap.appendChild(ynLabel);
          const ynBtns = document.createElement('div');
          ynBtns.className     = 'sf-yn-btns';
          ynBtns.style.cssText = 'display:flex;gap:10px;';
          ['Yes', 'No'].forEach(val => {
            const btn = document.createElement('button');
            btn.type          = 'button';
            btn.className     = 'sf-yn-btn';
            btn.textContent   = val;
            btn.style.cssText = 'padding:8px 24px;border-radius:6px;border:1px solid #d1d5db;background:#fff;cursor:pointer;font-family:inherit;font-size:1em;transition:all .15s;';
            if (existing.inoculated === val) {
              btn.style.background  = '#111';
              btn.style.color       = '#fff';
              btn.style.borderColor = '#111';
              ynBtns.dataset.value  = val;
            }
            ynBtns.appendChild(btn);
          });
          ynWrap.appendChild(ynBtns);
          card.appendChild(ynWrap);
          const uploaderWrap     = document.createElement('div');
          uploaderWrap.className = 'sf-contam-uploader-wrap';
          card.appendChild(SF.makeField('Photos of the contamination', uploaderWrap));
          app.uploaders['contam_' + item.id] = SF.mountUploader(uploaderWrap, { label: 'Upload photos' });
          card.appendChild(SF.makeButton(
            app.contamIdx < app.contamItems.length - 1 ? 'Continue to next item' : 'Review & submit',
            'contam-detail-next'
          ));
          SF.show(card);
          break;
        }

        case 'contam-submit': {
          const card = SF.makeCard();
          card.appendChild(SF.makeBackButton());
          card.appendChild(SF.makeHeading('Anything else to add?'));
          card.appendChild(SF.makeSubtitle('Optional — add any extra details that might help us.'));
          card.appendChild(SF.makeStatusEl());
          card.appendChild(SF.makeField('Additional notes', SF.makeTextarea('sf-contam-notes', 5, 'Any other details…'), true));
          card.appendChild(SF.makeButton('Create support ticket', 'submit-contam'));
          SF.show(card);
          break;
        }

        case 'product-select': {
          const card = SF.makeCard();
          card.appendChild(SF.makeBackButton());
          card.appendChild(SF.makeHeading('Which item(s) have a problem?'));
          card.appendChild(SF.makeSubtitle('Select all affected items from your order.'));
          card.appendChild(SF.makeStatusEl());
          const selectedIds = new Set(app.productProblemItems.map(x => String(x.id)));
          card.appendChild(SF.buildItemList(app.selectedOrder?.line_items || [], selectedIds, (li, checked) => {
            if (checked) { if (!app.productProblemItems.some(x => String(x.id) === String(li.id))) app.productProblemItems.push(li); }
            else { app.productProblemItems = app.productProblemItems.filter(x => String(x.id) !== String(li.id)); }
          }));
          card.appendChild(SF.makeButton('Continue', 'product-items-next'));
          SF.show(card);
          break;
        }

        case 'product-detail': {
          const item = app.productProblemItems[app.productProblemIdx];
          if (!item) { SF.submitProductProblem(); return; }
          const existing = app.productProblemDetails[item.id] || {};
          const card     = SF.makeCard();
          const stepEl   = document.createElement('p');
          stepEl.className   = 'sf-subtitle';
          stepEl.textContent = 'Item ' + (app.productProblemIdx + 1) + ' of ' + app.productProblemItems.length;
          card.appendChild(SF.makeBackButton());
          card.appendChild(stepEl);
          card.appendChild(SF.makeProductIdentity(item));
          card.appendChild(SF.makeStatusEl());
          const issueArea = SF.makeTextarea('sf-product-issue-desc', 5, 'Describe the issue with this item…', existing.description || '');
          card.appendChild(SF.makeField('What is the issue with this item?', issueArea));
          const uploaderWrap     = document.createElement('div');
          uploaderWrap.className = 'sf-product-uploader-wrap';
          card.appendChild(SF.makeField('Photos', uploaderWrap, true));
          app.uploaders['product_' + item.id] = SF.mountUploader(uploaderWrap, { label: 'Upload photos' });
          card.appendChild(SF.makeButton(
            app.productProblemIdx < app.productProblemItems.length - 1 ? 'Continue to next item' : 'Create support ticket',
            'product-detail-next'
          ));
          SF.show(card);
          break;
        }

        case 'contact-form':
          SF.renderContactForm({
            subject: SF.buildSubject(),
            message: app.issueType === 'missing-item' && app.missingItems.length
              ? SF.buildMissingItemMessage() : '',
            tags: ['order', app.issueType || ''].filter(Boolean),
          });
          break;

        case 'success':
          SF.renderSuccess();
          break;

        default:
          SF.show(SF.tpl('tpl-choose-issue'));
      }
    } catch (err) { SF.renderFatal(err); }
  };

      // ── renderTop ─────────────────────────────────────────────────────────────
  SF.renderTop = function () {
    const top = SF.getTopHash();
    SF.app.top = top;
    SF.debugLog('top=' + (top || '(home)'));
    switch (top) {
      case '':
        SF.show(SF.tpl('tpl-choose-category'));
        return;
      case 'cultivation':
        SF.show(SF.hasTpl('tpl-cultivation') ? SF.tpl('tpl-cultivation') : SF.tpl('tpl-choose-category'));
        return;
      case 'website':
        if (SF.hasTpl('tpl-website-problem')) {
          const f = SF.tpl('tpl-website-problem');
          SF.app.uploaders.website = SF.mountUploader(f.querySelector('.sf-website-uploader'), { label: 'Attach screenshots' });
          SF.show(f);
        } else {
          SF.show(SF.tpl('tpl-choose-category'));
        }
        return;
      case 'other':
        SF.show(SF.tpl('tpl-something-else'));
        return;
      case 'order-problem':
        if (!SF.isLoggedIn()) { SF.renderNotLoggedIn(); return; }
        SF.resetFlow();
        SF.renderStep();
        return;
    }
  };

  // ── Hash change listener ───────────────────────────────────────────────────
  window.addEventListener('hashchange', () => {
    try { SF.renderTop(); } catch (err) { SF.renderFatal(err); }
  });

  // ── Click handler ──────────────────────────────────────────────────────────
  SF.main.addEventListener('submit', e => e.preventDefault(), true);

  SF.main.addEventListener('click', async e => {
    const t = e.target instanceof Element ? e.target : null;
    if (!t) return;
    const app = SF.app;

    // ── Y/N buttons ──────────────────────────────────────────────────────────
    const ynBtn = t.closest('.sf-yn-btn');
    if (ynBtn) {
      const group = ynBtn.closest('.sf-yn-btns');
      if (group) {
        group.querySelectorAll('.sf-yn-btn').forEach(b => {
          b.style.background  = '#fff';
          b.style.color       = '#111';
          b.style.borderColor = '#d1d5db';
          delete b.dataset.selected;
        });
        ynBtn.style.background  = '#111';
        ynBtn.style.color       = '#fff';
        ynBtn.style.borderColor = '#111';
        ynBtn.dataset.selected  = 'true';
        group.dataset.value     = ynBtn.textContent.trim();
      }
      return;
    }

    // ── Back ��────────────────────────────────────────────────────────────────
    if (t.closest('[data-action="back"],.sf-back')) {
      if (app.top === 'order-problem' && app.stepStack.length > 0) SF.popStep();
      else SF.goTop('');
      return;
    }

    // ── Category selection ────────────────────────────────────────────────────
    const cat = t.closest('[data-category]');
    if (cat) {
      const v = (cat.getAttribute('data-category') || '').toLowerCase();
      SF.goTop(
        v === 'order-problem' ? 'order-problem' :
        v === 'website'       ? 'website'       :
        v === 'cultivation'   ? 'cultivation'   :
        v === 'other'         ? 'other' : ''
      );
      return;
    }

    // ── Other form ────────────────────────────────────────────────────────────
    if (t.closest('[data-action="show-other-form"]')) {
      app.top = 'other';
      SF.renderOtherForm();
      return;
    }

    // ── Top-level submits ─────────────────────────────────────────────────────
    if (t.closest('[data-action="submit-other"]'))   { await SF.submitOther();       return; }
    if (t.closest('[data-action="submit-contact"]')) { await SF.submitContactForm(); return; }

    if (app.top !== 'order-problem') return;

    // ── Issue type selection ──────────────────────────────────────────────────
    const issue = t.closest('[data-issue]');
    if (issue) {
      app.issueType = (issue.getAttribute('data-issue') || '').toLowerCase();
      try { await SF.loadOrders(); } catch (err) { SF.renderFatal(err); return; }
      SF.pushStep('select-order');
      return;
    }

    // ── Select order: continue ────────────────────────────────────────────────
    if (app.step === 'select-order') {
      const btn = t.closest('button,a,[role="button"]');
      if (btn && (btn.textContent || '').trim().toLowerCase() === 'continue') {
        if (!app.selectedOrder) return;
        const nextStepMap = {
          'not-arrived':     'delivery-type',
          'missing-item':    'missing-item',
          'damaged':         'damaged-packaging',
          'contaminated':    'contam-select',
          'product-problem': 'product-select',
        };
        SF.pushStep(nextStepMap[app.issueType] || 'contact-form');
        return;
      }
    }

    // ── Delivery type ─────────────────────────────────────────────────────────
    if (app.step === 'delivery-type') {
      const btn = t.closest('[data-delivery]');
      if (btn) {
        app.deliverySubType = btn.getAttribute('data-delivery');
        if (app.deliverySubType === 'other') {
          SF.pushStep('contact-form');
        } else if (app.deliverySubType === 'wrong-address') {
          SF.pushStep('delivery-roadblock');
        } else {
          SF.pushStep('delivery-info');
        }
        return;
      }
    }

    // ── Delivery info ─────────────────────────────────────────────────────────
    if (app.step === 'delivery-info') {
      if (t.closest('[data-action="delivery-still-missing"]')) {
        SF.pushStep('delivery-roadblock');
        return;
      }
      if (t.closest('[data-action="delivery-contact"]')) {
        SF.pushStep('contact-form');
        return;
      }
      if (t.closest('[data-action="delivery-force-contact"]')) {
        SF.renderContactForm({
          subject: 'Order ' + (app.selectedOrder?.name || '') + ' delivery issue',
          message: '',
          tags:    ['order', 'issue:delivery', 'subtype:early-contact'],
        });
        return;
      }
    }

    // ── Delivery roadblock ────────────────────────────────────────────────────
    if (app.step === 'delivery-roadblock') {
      if (t.closest('[data-action="delivery-still-missing"]')) {
        SF.pushStep('delivery-message');
        return;
      }
    }

    // ── Missing items: continue ───────────────────────────────────────────────
    if (app.step === 'missing-item') {
      const btn = t.closest('button,a,[role="button"]');
      if (btn && (btn.textContent || '').trim().toLowerCase() === 'continue') {
        if (!app.missingItems.length) { SF.setStatus('Please select at least one missing item.', 'error'); return; }
        SF.pushStep('contact-form');
        return;
      }
    }

    // ── Damaged packaging choice ──────────────────────────────────────────────
    if (app.step === 'damaged-packaging') {
      const pkg = t.closest('[data-packaging]');
      if (pkg) {
        app.packagingDamaged = pkg.getAttribute('data-packaging') === 'true';
        SF.pushStep('damaged-items');
        return;
      }
    }

    // ── Damaged items: continue ───────────────────────────────────────────────
    if (app.step === 'damaged-items') {
      const btn = t.closest('button,a,[role="button"]');
      if (btn && (btn.textContent || '').trim().toLowerCase() === 'continue') {
        if (app.uploaders.parcel?.isUploading?.()) { SF.setStatus('Please wait for upload to finish.', 'error'); return; }
        app.parcelKeys = app.uploaders.parcel?.getKeys?.() || [];
        if (app.packagingDamaged && !app.parcelKeys.length) { SF.setStatus('Please upload a photo of the damaged parcel.', 'error'); return; }
        if (!app.damagedItems.length) { SF.setStatus('Please select which item(s) were damaged.', 'error'); return; }
        app.damagedIdx = 0;
        SF.pushStep('damaged-item-detail');
        return;
      }
    }

    // ── Damaged item detail: continue ─────────────────────────────────────────
    if (app.step === 'damaged-item-detail') {
      const btn = t.closest('button,a,[role="button"]');
      if (btn && (btn.textContent || '').trim().toLowerCase() === 'continue') {
        const item = app.damagedItems[app.damagedIdx];
        if (!item) { SF.pushStep('damaged-extra'); return; }
        if (app.uploaders.item?.isUploading?.()) { SF.setStatus('Please wait for upload to finish.', 'error'); return; }
        const keys = app.uploaders.item?.getKeys?.() || [];
        const desc = SF.main.querySelector('.sf-damaged-item-desc')?.value?.trim() || '';
        if (!keys.length) { SF.setStatus('Please upload at least one photo.', 'error'); return; }
        if (!desc)        { SF.setStatus('Please describe the damage.',        'error'); return; }
        app.damagedItemDetails[item.id] = { attachmentKeys: keys, description: desc };
        app.damagedIdx += 1;
        if (app.damagedIdx >= app.damagedItems.length) SF.pushStep('damaged-extra');
        else SF.renderStep();
        return;
      }
    }

    // ── Damaged extra: submit ─────────────────────────────────────────────────
    if (app.step === 'damaged-extra') {
      if (t.closest('[data-action="submit-damaged"]')) {
        await SF.submitDamaged();
        return;
      }
    }

    // ── Contamination: items continue ─────────────────────────────────────────
    if (app.step === 'contam-select') {
      if (t.closest('[data-action="contam-items-next"]')) {
        if (!app.contamItems.length) { SF.setStatus('Please select at least one item.', 'error'); return; }
        app.contamIdx = 0;
        SF.pushStep('contam-detail');
        return;
      }
    }

    // ── Contamination: per-item continue ──────────────────────────────────────
    if (app.step === 'contam-detail') {
      if (t.closest('[data-action="contam-detail-next"]')) {
        const item = app.contamItems[app.contamIdx];
        if (!item) { SF.pushStep('contam-submit'); return; }
        const uploader   = app.uploaders['contam_' + item.id];
        if (uploader?.isUploading?.()) { SF.setStatus('Please wait for upload to finish.', 'error'); return; }
        const keys       = uploader?.getKeys?.() || [];
        const lot        = SF.main.querySelector('.sf-contam-lot')?.value?.trim() || '';
        const inoculated = SF.main.querySelector('.sf-yn-btns')?.dataset?.value  || '';
        if (!lot)         { SF.setStatus('Please enter the lot number or date label.',            'error'); return; }
        if (!inoculated)  { SF.setStatus('Please indicate whether this product was inoculated.', 'error'); return; }
        if (!keys.length) { SF.setStatus('Please upload at least one photo.',                    'error'); return; }
        app.contamDetails[item.id] = { lot, inoculated, attachmentKeys: keys };
        app.contamIdx += 1;
        if (app.contamIdx >= app.contamItems.length) SF.pushStep('contam-submit');
        else SF.renderStep();
        return;
      }
    }

    // ── Contamination: final submit ───────────────────────────────────────────
    if (app.step === 'contam-submit') {
      if (t.closest('[data-action="submit-contam"]')) {
        await SF.submitContam();
        return;
      }
    }

    // ── Product problem: items continue ───────────────────────────────────────
    if (app.step === 'product-select') {
      if (t.closest('[data-action="product-items-next"]')) {
        if (!app.productProblemItems.length) { SF.setStatus('Please select at least one item.', 'error'); return; }
        app.productProblemIdx = 0;
        SF.pushStep('product-detail');
        return;
      }
    }

    // ── Product problem: per-item continue / submit ────────────────────────────
    if (app.step === 'product-detail') {
      if (t.closest('[data-action="product-detail-next"]')) {
        const item = app.productProblemItems[app.productProblemIdx];
        if (!item) { await SF.submitProductProblem(); return; }
        const desc = SF.main.querySelector('.sf-product-issue-desc')?.value?.trim() || '';
        if (!desc) { SF.setStatus('Please describe the issue with this item.', 'error'); return; }
        const uploader = app.uploaders['product_' + item.id];
        if (uploader?.isUploading?.()) { SF.setStatus('Please wait for upload to finish.', 'error'); return; }
        const keys = uploader?.getKeys?.() || [];
        app.productProblemDetails[item.id] = { description: desc, attachmentKeys: keys };
        app.productProblemIdx += 1;
        if (app.productProblemIdx >= app.productProblemItems.length) {
          await SF.submitProductProblem();
        } else {
          SF.renderStep();
        }
        return;
      }
    }

  });

  // ── Boot ───────────────────────────────────────────────────────────────────
  try { SF.renderTop(); } catch (err) { SF.renderFatal(err); }

})();